import React from 'react';
import MyInput from "../../../shared/form/MyInput";
import trash from "../../../../media/icons/trash.svg"

const Prices = ({ priceRates, changePriceRates, captureErrors }) => {

  const deleteRate = (key) => {
    const newPriceRates = [];

    for (let i = 0; i < priceRates.length; i++) {
      if (i !== key) {
        newPriceRates.push(priceRates[i])
      }
    }

    changePriceRates(newPriceRates)
  };

  const change = (key, event) => {
    priceRates[key][event.target.name] = event.target.value;
    changePriceRates(priceRates)
  };

  const changePriceDay = (key, event) => {
    priceRates[key].pricing[event.target.name] = event.target.value;
    changePriceRates(priceRates)
  };


  return (
    <div className="container-fluid">
      {priceRates.map((rate, key) =>
        <React.Fragment key={key}>
          <div className="row p-2 pt-3 bg-light">
            <div className="col">
              <MyInput title="Mes inicial" type="number" name="startMonth" value={rate.startMonth}
                       onChange={(event) => change(key, event)} captureErrors={captureErrors} notEmpty={true}
                       maxChar={2}/>
            </div>
            <div className="col">
              <MyInput title="Mes final" type="number" name="endMonth" value={rate.endMonth}
                       onChange={(event) => change(key, event)} captureErrors={captureErrors} notEmpty={true}
                       maxChar={2}/>
            </div>
            <div className="col">
              <MyInput title="Precio por día extra" type="number" name="extra" value={rate.extra}
                       onChange={(event) => change(key, event)} captureErrors={captureErrors} notEmpty={true}/>
            </div>
          </div>
          <div className="row p-2 bg-light">
            <div className="col">
              <MyInput title="Día 1" type="number" name="1" value={rate.pricing[1]}
                       onChange={(event) => changePriceDay(key, event)} captureErrors={captureErrors} notEmpty={true}/>
            </div>
            <div className="col">
              <MyInput title="Día 2" type="number" name="2" value={rate.pricing[2]}
                       onChange={(event) => changePriceDay(key, event)} captureErrors={captureErrors} notEmpty={true}/>
            </div>
            <div className="col">
              <MyInput title="Día 3" type="number" name="3" value={rate.pricing[3]}
                       onChange={(event) => changePriceDay(key, event)} captureErrors={captureErrors} notEmpty={true}/>
            </div>
            <div className="col">
              <MyInput title="Día 4" type="number" name="4" value={rate.pricing[4]}
                       onChange={(event) => changePriceDay(key, event)} captureErrors={captureErrors} notEmpty={true}/>
            </div>
            <div className="col">
              <MyInput title="Día 5" type="number" name="5" value={rate.pricing[5]}
                       onChange={(event) => changePriceDay(key, event)} captureErrors={captureErrors} notEmpty={true}/>
            </div>
            <div className="col">
              <MyInput title="Día 6" type="number" name="6" value={rate.pricing[6]}
                       onChange={(event) => changePriceDay(key, event)} captureErrors={captureErrors} notEmpty={true}/>
            </div>
          </div>
          <div className="row justify-content-end bg-light mb-3 px-3 pb-3 pt-0">
            <img width="20px" height="20px" style={{cursor: "pointer"}} onClick={() => deleteRate(key)} src={trash} alt=""/>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default Prices;
